module.exports = __webpack_public_path__ + "window_frames-2b463e73eeb52cb8901f1caf78ab90d4.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/assets/window_frames.png
// module id = yJDZ
// module chunks = client